import "../sass/style.scss";
import "./keyboard";
import Image from "./image";
import "./canvas";
import {
  toggleAutorotation,
  startChange
} from "./changeView";
import {
  setSourceArray,
  clearInternalInterval,
  getPath,
  setViewer,
  changeSrc,
  isSmothZoom,
  xlength,
  ylength,
  app,
  settings,
  setCurrentImage,
  changeFullScreeenMode
} from "./variable";
import {
  initStyles,
  exit
} from "./style";
import {
  zoomStart,
  zoomStop
} from "./zoom";
import OpenSeadragon from "openseadragon";

const init = () => {
  const initImage = new Image(
    settings.animation_settings.start_row,
    settings.animation_settings.start_col
  );

  initStyles();
  if (isSmothZoom) {
    changeSrc(initImage);
  } else {
    setCurrentImage(initImage);

    let sourceArray = [];
    [...Array(ylength + 1).keys()].forEach((y) => {
      [...Array(xlength + 1).keys()].forEach((x) => {
        sourceArray.push(getPath(new Image(x, y)));
      });
    });

    setSourceArray(sourceArray);

    let viewer = new OpenSeadragon({
      defaultZoomLevel: 1,
      minZoomLevel: 1,
      maxZoomLevel: 10,
      id: "image",
      showHomeControl: false,
      showFullPageControl: false,
      zoomOutButton: "zoomOut",
      zoomInButton: "zoomIn",
      visibilityRatio: 1.0,
      constrainDuringPan: true,
      tileSources: sourceArray[initImage.y * (xlength + 1) + initImage.x]
    });
    viewer.gestureSettingsMouse.clickToZoom = false;
    viewer.gestureSettingsMouse.scrollToZoom = true;
    setViewer(viewer, initImage);
  }
};

window.onload = init();
window.endChange = () => clearInternalInterval();
window.startChange = (direction) => startChange(direction);
window.toggleAutorotation = () => toggleAutorotation();
window.zoomStart = (option) => zoomStart(option);
window.zoomStop = () => zoomStop();
window.exitDialog = () => exit();
window.toggleFullScreen = () => changeFullScreeenMode();